// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .tutorial-form-dialog .p-dialog-header {
  background: #0066B2;
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::ng-deep .tutorial-form-dialog .p-dialog-header .custom-dialog-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}
::ng-deep .tutorial-form-dialog .p-dialog-header .dialog-close-btn {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
::ng-deep .tutorial-form-dialog .p-dialog-header .dialog-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg) scale(1.1);
  border-color: rgba(255, 255, 255, 0.3);
}
::ng-deep .tutorial-form-dialog .p-dialog-header .dialog-close-btn:active {
  transform: rotate(90deg) scale(0.95);
}
::ng-deep .tutorial-form-dialog .p-dialog-content {
  padding: 20px;
}
::ng-deep .tutorial-form-dialog .p-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.form-group {
  margin-bottom: 16px;
}
.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #3a3a3a;
  margin-bottom: 6px;
}
.form-group label .required {
  color: #e74c3c;
}
.form-group label .optional {
  font-weight: 400;
  color: #777;
}
.form-group .form-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #EFEFEF;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}
.form-group .form-input:focus {
  outline: none;
  border-color: #0066B2;
  box-shadow: 0 0 0 3px rgba(0, 102, 178, 0.1);
}
.form-group .form-input.invalid {
  border-color: #e74c3c;
}
.form-group .field-hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #777;
}
.form-group .field-hint.error {
  color: #e74c3c;
}
.form-group .form-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #EFEFEF;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}
.form-group .form-textarea:focus {
  outline: none;
  border-color: #0066B2;
  box-shadow: 0 0 0 3px rgba(0, 102, 178, 0.1);
}
.form-group.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
}
.form-group.checkbox-group label input[type=checkbox] {
  width: 16px;
  height: 16px;
  accent-color: #0066B2;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid #EFEFEF;
  margin-top: 8px;
}
.dialog-actions .btn-cancel {
  padding: 9px 20px;
  border: 1px solid #EFEFEF;
  background: white;
  color: #777;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.dialog-actions .btn-cancel:hover {
  border-color: #0066B2;
  color: #0066B2;
}
.dialog-actions .btn-save {
  padding: 9px 20px;
  border: none;
  background: #0066B2;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.dialog-actions .btn-save:hover:not(:disabled) {
  background: #0B2D71;
}
.dialog-actions .btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
